export default {
  contactUs: 'https://w.amazon.com/bin/view/WWCFT/Products/FAE/ContactUs',
  wiki: 'https://w.amazon.com/bin/view/WWCFT/Products/FAE/Home',
  phoneTool: 'https://phonetool.amazon.com/users',
  Issue: 'https://w.amazon.com/bin/view/WWCFT/Products/FAE/ReportsIssue',
};
